import { render, staticRenderFns } from "./IconActionCards.vue?vue&type=template&id=904e300a&scoped=true&"
import script from "./IconActionCards.vue?vue&type=script&lang=ts&"
export * from "./IconActionCards.vue?vue&type=script&lang=ts&"
import style0 from "./IconActionCards.vue?vue&type=style&index=0&id=904e300a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904e300a",
  null
  
)

export default component.exports